import React from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useAppConfig } from "@limitless/common/hooks";
import { useExpertMessageContext } from "../../../hooks/expert-message/ExpertMessageContext";
import { useExpertSuggestedAnswersContext } from "../../../hooks/expert-suggested-answers/ExpertSuggestedAnswersContext";
import { useMessageClaimExtension } from "../../../hooks/MessageClaimExtensionHook";
import { useExpertProfileContext } from "../../../hooks/expert-profile/ExpertProfileContext";
const ExpertMessageDetail = ({
  children
}) => {
  const {
    claimMessage,
    addDialogue,
    addAttachment,
    message,
    clearMessage,
    switchToRespond
  } = useExpertMessageContext();
  const {
    saState
  } = useExpertSuggestedAnswersContext();
  const {
    countryList,
    getLanguageFromLanguageCode
  } = useAppConfig();
  const {
    profile
  } = useExpertProfileContext();
  const handleClaimMessage = () => {
    claimMessage();
  };
  const handleAddDialogue = (body, aiOptions = {}) => {
    //we wire in SA state here as we don't want to make MessageHook dependant on SA hook
    addDialogue(body, saState, aiOptions);
  };
  const handleAddAttachment = (file, caption, uploadAttachmentOverride) => {
    addAttachment(file, caption, uploadAttachmentOverride);
  };
  const handleSwitchToRespond = () => {
    switchToRespond();
  };
  const translationLanguage = React.useMemo(() => {
    var _message$dialogues;
    if (message.conversationState.showTransaltedLanguageText && ((_message$dialogues = message.dialogues) === null || _message$dialogues === void 0 ? void 0 : _message$dialogues.length) > 0) {
      const dialogueLocale = message.dialogues[0].locale;
      const languageNameFromLocale = getLanguageFromLanguageCode(dialogueLocale);
      let intlLanguageName;
      try {
        if (Intl) {
          intlLanguageName = new Intl.DisplayNames(["en"], {
            type: "language"
          }).of(dialogueLocale);
        }
      } catch {
        intlLanguageName = null;
      }
      const languageNames = intlLanguageName ? intlLanguageName : languageNameFromLocale ? languageNameFromLocale : dialogueLocale;
      return languageNames;
    }
    return null;
  }, [message.dialogues]);
  return children({
    loading: message.loading,
    onClaimMessage: handleClaimMessage,
    onAddDialogue: handleAddDialogue,
    onSendAttachment: handleAddAttachment,
    onSwitchToRespond: handleSwitchToRespond,
    message,
    clearMessage,
    profile,
    countryList,
    ...useMessageClaimExtension(),
    translationLanguage
  });
};
export default ExpertMessageDetail;
ExpertMessageDetail.propTypes = {
  children: PropTypes.func.isRequired
};